import styles from '../loader/loader.module.css';

export const Loader = () => {
    return <div className={styles.ldsRing}><div></div><div></div><div></div><div></div></div>
}